import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { ScheduledTransaction, ScheduledTransactionType } from './scheduledTransactionsTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const syncSchTxnPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<ScheduledTransactionType>>();
const schTxnPayloadCreator = getPayloadCreator<ScheduledTransaction>();
const schTxnsPayloadCreator = getPayloadCreator<ScheduledTransaction[]>();
const billScoutPayloadCreator = getPayloadCreator<{ clientId: string; id: string }>();

export const getScheduledTransactions = createAction('GET_SCHEDULED_TRANSACTIONS', getPayloadCreator());
export const getScheduledTransactionsSuccess = createAction(
  'GET_SCHEDULED_TRANSACTIONS_SUCCESS',
  syncSchTxnPayloadCreator,
);
export const getScheduledTransactionsFailure = createAction('GET_SCHEDULED_TRANSACTIONS_FAILURE', errorPayloadCreator);

export const createScheduledTransaction = createAction('CREATE_SCHEDULED_TRANSACTION', schTxnPayloadCreator);
export const createScheduledTransactionSuccess = createAction(
  'CREATE_SCHEDULED_TRANSACTION_SUCCESS',
  schTxnPayloadCreator,
);
export const createScheduledTransactionFailure = createAction(
  'CREATE_SCHEDULED_TRANSACTION_FAILURE',
  errorPayloadCreator,
);

export const updateScheduledTransaction = createAction('UPDATE_SCHEDULED_TRANSACTION', schTxnPayloadCreator);
export const updateScheduledTransactionSuccess = createAction(
  'UPDATE_SCHEDULED_TRANSACTION_SUCCESS',
  schTxnPayloadCreator,
);
export const updateScheduledTransactionFailure = createAction(
  'UPDATE_SCHEDULED_TRANSACTION_FAILURE',
  errorPayloadCreator,
);

export const deleteScheduledTransaction = createAction('DELETE_SCHEDULED_TRANSACTION', schTxnPayloadCreator);
export const deleteScheduledTransactionSuccess = createAction(
  'DELETE_SCHEDULED_TRANSACTION_SUCCESS',
  schTxnPayloadCreator,
);
export const deleteScheduledTransactionFailure = createAction(
  'DELETE_SCHEDULED_TRANSACTION_FAILURE',
  errorPayloadCreator,
);

export const batchScheduledTransactions = createAction('BATCH_SCHEDULED_TRANSACTIONS', schTxnsPayloadCreator);
export const batchScheduledTransactionsSuccess = createAction(
  'BATCH_SCHEDULED_TRANSACTIONS_SUCCESS',
  schTxnsPayloadCreator,
);
export const batchScheduledTransactionsFailure = createAction(
  'BATCH_SCHEDULED_TRANSACTIONS_FAILURE',
  schTxnsPayloadCreator,
);

export const createBillScoutSchedule = createAction('CREATE_BILLSCOUT_SCHEDULE', billScoutPayloadCreator);
export const createBillScoutScheduleSuccess = createAction(
  'CREATE_BILLSCOUT_SCHEDULE_SUCCESS',
  billScoutPayloadCreator,
);
export const createBillScoutScheduleFailure = createAction('CREATE_BILLSCOUT_SCHEDULE_FAILURE', errorPayloadCreator);
